import { animated } from "@react-spring/web";
import Lottie from "lottie-react";
import { FormattedMessage } from "react-intl";
import ClickAnimation from "../../shared/assets/images/click-anim.json";
import PlaneImage from "../../shared/assets/images/plane.webp";
import ButtonMenu from "../../shared/ui/ButtonMenu/ButtonMenu";
import Obstacles from "../../shared/ui/Obstacles/Obstacles";
import { useGameEngine } from "./model/use-game-engine";
import cls from "./Game.module.scss";

const Game = () => {
  const {
    firstClick,
    containerRef,
    springPropsBall,
    springPropsContainer,
    onContainerTouchStart,
    onContainerClick,
    onContainerKeyDown,
  } = useGameEngine();

  return (
    <div
      className={cls.mainContainer}
      onTouchStart={onContainerTouchStart}
      onClick={onContainerClick}
    >
      <ButtonMenu />

      <animated.img
        className={`${cls.BallImage}`}
        alt="Plane"
        src={PlaneImage}
        style={{ ...springPropsBall }}
      />
      <animated.div
        ref={containerRef}
        className={cls.container}
        style={{ ...springPropsContainer }}
        onKeyDown={onContainerKeyDown}
        tabIndex={0}
      >
        {firstClick && (
          <>
            <Lottie
              className={cls.cursorImage}
              animationData={ClickAnimation}
              loop={true}
            />
            <p>
              <FormattedMessage
                id="game__manual-text"
                values={{
                  br: <br />,
                }}
              />
            </p>
          </>
        )}
        <canvas id="collisionCanvas" width="400" height="400"></canvas>
        <Obstacles />
      </animated.div>
    </div>
  );
};

export default Game;
